<template>
<EntityReport entity="ReportAccidents" />
</template>

<script>
export default {

}
</script>
